import { ModelsState } from 'src_common/common/websocket2/ModelsState';
import { createGuard } from 'src_common/common/createGuard';
import * as t from 'io-ts';
import { TypeId } from 'src_common/common/websocket2/type';

const isNumber = createGuard(t.number);

interface ErrorObj {
    name: string,
    code: string,
    priceSelection?: string,
    priceBet?: string,
}

export const getSelectionErrors = (
    models: ModelsState,
    eventId: number | null,
    marketId: number | null,
    selectionId: number | null,
    errorCode: string | null,
    legPrice: string | null,
    valueF: string | null,
): ErrorObj | null => {

    if (isNumber(selectionId) && isNumber(marketId) && isNumber(eventId)) {
        const selectionModel = models.getSelectionAndLoad(TypeId.newMarketId(eventId, marketId), selectionId);

        if (['decreased', 'increased'].indexOf(errorCode ?? '') !== -1 && valueF !== null) {
            return {
                name: selectionModel?.name ?? '',
                code: errorCode ?? '',
                priceSelection: valueF,
                priceBet: legPrice ?? ''
            };
        } else {
            return { name: selectionModel?.name ?? '', code: errorCode ?? '' };
        }
    }

    return null;
};
